import { Navigate, PathRouteProps, Route, RouteProps } from "react-router-dom";
import { checkAuth } from "../../libs/auth";
import { FC, memo, ReactElement } from "react";
import { areEqual } from "../../libs/utils";

interface Props extends PathRouteProps {
  element: ReactElement;
}

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  if (checkAuth()) {
    return children;
    console.log("Privateroute");
  }
  return <Navigate to="/login" />;
};

export default memo(PrivateRoute, areEqual);
